import { AttributeType, Draft, SchemaAttribute } from "types/customEvents";

export const checkIfSchemaAreInEditMode = () => {
  const editingRules = document.querySelectorAll("div[data-attr-edit]");
  const error = document.querySelector('p[id="data-rules-edit"]');

  const areSchemaInEditMode = editingRules.length > 0;

  if (areSchemaInEditMode) {
    error?.classList.add("error-edit-display");
  } else {
    error?.classList.remove("error-edit-display");
  }

  return areSchemaInEditMode;
};

export const markEditResolved = (path: string) => {
  const element = document.querySelector(`div[data-attr-edit="${path}"]`);
  element?.removeAttribute("data-attr-edit");

  checkIfSchemaAreInEditMode();
};

export const getRawAttribute = ({
  isEditing,
  isSaved,
  draft,
  ...rest
}: AttributeType): Draft | SchemaAttribute =>
  isEditing ? (draft as Draft) : (rest as SchemaAttribute);
